module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp2_9006.523f6389.png";